import { Button } from 'components/Button/Button';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import appHelpers from 'utils/app-urls';
import messages from './messages';

const Success = ({ onContinue }: { onContinue?: () => void }) => {
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );
  const cdnURL = appHelpers.getCDNUrl();
  const successMessages = messages[language].accountUpdated;

  return (
    <div className="text-center">
      <img
        src={`${cdnURL}assets/register/thumbs-up.png`}
        alt={successMessages.thumbsUpAlt}
        className="mt-4 mb-4 center"
      />
      <h1 className="font-semibold leading-9 pl-11 pr-11 text-2.5x1 text-center mt-4 mb-6">
        {successMessages.heading}
      </h1>
      <Button onClick={onContinue} continue full className="w-full max-w-xs">
        {successMessages.continueButton}
      </Button>
    </div>
  );
};

export default Success;
